import supabase from './supabaseClient'

class SupabaseAuthService {
    async signInWithPassword(email, password) {
        const { data, error } = await supabase.auth.signInWithPassword({ email, password })
        if (error) throw error
        return data
    }

    async signUpWithPassword(email, password, metadata = {}) {
        const { data, error } = await supabase.auth.signUp({
            email,
            password,
            options: {
                data: metadata
            }
        })
        if (error) throw error
        return data
    }

    async signInWithOtp(email) {
        // 发送邮箱一次性验证码（magic link / email otp）
        const { data, error } = await supabase.auth.signInWithOtp({ email, options: { shouldCreateUser: true, emailRedirectTo: window.location.origin } })
        if (error) throw error
        return data
    }

    async verifyEmailOtp(email, token) {
        // 验证邮箱 OTP（类型: email）
        const { data, error } = await supabase.auth.verifyOtp({ email, token, type: 'email' })
        if (error) throw error
        return data
    }

    async signInWithOAuth(provider, scopes) {
        const { data, error } = await supabase.auth.signInWithOAuth({
            provider,
            options: {
                redirectTo: window.location.origin,
                scopes
            }
        })
        if (error) throw error
        return data
    }

    async signInWithGoogle() {
        return this.signInWithOAuth('google', 'email profile openid')
    }

    async signInWithGithub() {
        return this.signInWithOAuth('github', 'read:user user:email')
    }

    async signOut() {
        const { error } = await supabase.auth.signOut()
        if (error) throw error
    }

    async getSession() {
        const { data } = await supabase.auth.getSession()
        return data.session || null
    }

    async getCurrentUser() {
        const { data } = await supabase.auth.getUser()
        return data.user || null
    }

    async ensureAdmin() {
        const user = await this.getCurrentUser()
        if (!user) return false
        const { data, error } = await supabase
            .from('profiles')
            .select('role')
            .eq('user_id', user.id)
            .single()
        if (error) return false
        return data?.role === 'admin'
    }

    // 验证用户名是否已存在
    async checkUsernameExists(username) {
        try {
            const { data, error } = await supabase
                .rpc('check_username_exists', { username_to_check: username })

            if (error) {
                console.error('检查用户名失败:', error)
                throw new Error('验证用户名时发生错误')
            }

            return data || false
        } catch (error) {
            console.error('检查用户名失败:', error)
            throw new Error('验证用户名时发生错误')
        }
    }

    // 验证邮箱是否已存在
    async checkEmailExists(email) {
        try {
            const { data, error } = await supabase
                .rpc('check_email_exists', { email_to_check: email })

            if (error) {
                console.error('检查邮箱失败:', error)
                throw new Error('验证邮箱时发生错误')
            }

            return data || false
        } catch (error) {
            console.error('检查邮箱失败:', error)
            throw new Error('验证邮箱时发生错误')
        }
    }

    // 更新密码
    async updatePassword(newPassword) {
        try {
            const { error } = await supabase.auth.updateUser({
                password: newPassword
            })
            if (error) throw error
            return true
        } catch (error) {
            console.error('更新密码失败:', error)
            throw new Error('更新密码失败')
        }
    }
}

const supabaseAuthService = new SupabaseAuthService()
export default supabaseAuthService 